export default "__VITE_ASSET__B58lpGvn__"